import React, { useState } from "react";
import { Context } from "../context";
import NavMenu from "./header/menu/nav-menu";
import QuickLinks from "./header/quicklinks";
import Logo from "./header/logo";
import Hamburger from "./header/hamburger";
import SearchForm from "../blocks/core/search";
const Header = ({ menuStateUpdate }) => {
    // const props = useStaticQuery(query);
    const context = React.useContext(Context);
    const logo = context.settings.general.themeSettings.siteLogo.localFile;
    const alternativeLogo = context.settings.general.themeSettings.siteLogoAlternative?.localFile;
    const title = context.settings.general.title;
    const description = context.settings.general.description;
    const [isMenuVisible, toggleMenu] = useState(false);
    return (React.createElement("header", { id: "header" },
        React.createElement("div", null,
            React.createElement(QuickLinks, null),
            context.settings.metadata.useSiteCatchphrase ? (React.createElement("div", { className: "logo" },
                React.createElement(Logo, { logo: logo, title: title }),
                React.createElement("p", null, description))) : (React.createElement(Logo, { logo: logo, title: title })),
            React.createElement(Hamburger, { id: "mainNav", onOpen: () => {
                    menuStateUpdate(true);
                    toggleMenu(true);
                }, onClose: () => {
                    menuStateUpdate(false);
                    toggleMenu(false);
                } }),
            React.createElement("div", { className: "menus" },
                React.createElement(NavMenu, { dropdown: "hover", nav: context.menus.main, id: "mainMenu", label: "Menu de navigation principal", visible: isMenuVisible }),
                context.settings.metadata.hasSearch ? React.createElement(SearchForm, null) : React.createElement(React.Fragment, null),
                context.settings.general.themeSettings.siteLogoAlternative ? (React.createElement(Logo, { logo: alternativeLogo, title: title })) : (React.createElement(React.Fragment, null)),
                React.createElement(NavMenu, { nav: context.menus.secondary, id: "secondaryMenu", label: "Menu de navigation secondaire", visible: isMenuVisible, containerClassName: "wp-block-button is-style-button-border" })))));
};
export default Header;
